import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "../Button";
import { Breadcrumb } from "../Breadcrumb";
import { useSelector, useDispatch } from "react-redux";
import { pushPage, updateFilters } from "store/state/stateSlice";
import { Select } from "../Select";
import { RootState } from "store";
import { useLoadBranchesList } from "hooks";

export function Filteration({
  createRoute,
  createModal,
  breadCrumbRoutes,
}: any) {
  const navigation = useNavigate();
  const dispatch = useDispatch();

  const { filters } = useSelector((state: any) => state.state);
  const { branchesList } = useSelector((state: RootState) => state.branch);
  const { onLoadBranchesList } = useLoadBranchesList();

  const [searchQuery, setSearchQuery] = useState<string>("");

  const filter = filters ? Object.keys(filters) : [];

  const visible = (value: string) => {
    return filter?.find((e) => e === value) ? false : true;
  };

  const pushFilter = async (filter: any) => {
    await dispatch(updateFilters(filter));
  };

  return (
    <div className="w-full flex  flex-col md:flex-row justify-between md:gap-100">
      <div className="flex items-center">
        <Breadcrumb routes={breadCrumbRoutes} />
      </div>

      <div className="gap-2 flex flex-col sm:flex-row w-full lg:w-auto justify-end">
        <div className="">
          {!visible("branchId") && (
            <div className=" pb-1 ">
              <Select
                name="branchId"
                touches=""
                options={branchesList}
                onChange={(item: any) => {
                  const updatedFilters = { ...filters };
                  updatedFilters.branchId = item?.id;
                  pushFilter(updatedFilters);
                  dispatch(pushPage(1 as any));
                }}
                values={{ branchId: filters?.branchId }}
                getOptionLabel="name"
                getOptionValue="id"
                placeholder="Select Branch"
              />
            </div>
          )}
        </div>
        <div className="flex items-center">
          {!visible("query") && (
            <input
              onChange={(item: any) => {
                const updatedFilters = { ...filters };
                updatedFilters.query = item?.target?.value?.replace(/^#/, '');
                setSearchQuery(item?.target?.value);
                pushFilter(updatedFilters);
                dispatch(pushPage(1 as any));
              }}
              value={searchQuery}
              type="text"
              className="text-xs text-black w-full h-9  p-[10px] border border-gray-200 rounded-md"
              placeholder="Search...."
            />
          )}
        </div>
        <div className="flex items-center">
          {createRoute && (
            <Button
              name="CREATE"
              onClick={() => [navigation(createRoute)]}
              className="px-6"
            />
          )}
          {createModal && (
            <Button
              name="CREATE"
              onClick={() => createModal(true)}
              className="px-6"
            />
          )}
        </div>
      </div>
    </div>
  );
}
